var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mt-5"},[_c('h3',[_c('b',[_vm._v(_vm._s(_vm.data)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }